<script>
    import ColorHelper from "../../helpers/color.helper";
    import OverlayPanel from 'primevue/overlaypanel';
    import Icon from "@/components/Icon/Icon.vue"; 
    import moment from 'moment'
    import userService from "@/services/user.service"
    import RightsEnum from "@/enum/rights.enum"

    export default {
        name: 'AppointmentItem',
        components: {
            OverlayPanel,
            Icon,
        },
        expose: ['updateDuration'],
        data() {
            return {
                colorHover: "#ffb95f",
                color: "#ffe1bb",
                colorPlace: '#ffffff',
                height: 0,
                zIndex: 1,
                top: 0,
            }
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
            agendaStart: {
                type: Number,
                default: 0,
            },
            agendaDuration: {
                type: Number,
                default: 24,
            },
            selected: {
                type: Number,
                default: 0,
            },
        },
        watch: {
            'item.date': function(newVal, oldVal) {
                if(moment(oldVal).format('YYYY-MM-DD') != newVal) {
                    this.$emit('change-date', this, oldVal, newVal)
                }
            },
            'item.time': function(newVal) {
                const timeArray = newVal.split(':');
                const minutes = ((+timeArray[0]) * 60 + (+timeArray[1]));

                if(this.moving === false)
                {
                    this.zIndex = minutes + 1
                }
                let top = (minutes - this.agendaStart * 60) * 100 / (this.agendaDuration * 60)
                this.top = top + '%'
            },
            'item.duration': function(newVal) {
                if(this.item.duration < 5)
                {
                    this.item.duration = 5
                }

                this.height = parseFloat(this.item.duration * 100 / (this.agendaDuration * 60)).toFixed(2) + '%';
            },
            'item.moving': function() {
                if(this.item.moving === true) {
                    this.zIndex = 1500
                }
                else {
                    const timeArray = this.item.time.split(':')

                    this.zIndex = ((+timeArray[0]) * 60 + (+timeArray[1])) + 1
                }
            }
        },
        methods: {
            toggle(event) {
                this.$refs.op.toggle(event);
            },
            selectItem() {
                this.$emit('select-item', this)
            },
            selectItemToMoveDown(event) {
                this.$emit('move-down-appointment', event, this)
            },
            selectItemToMoveUp(event) {
                this.$emit('move-up-appointment', event, this)
            },
            selectItemToMoveAll(event) {
                if(userService.hasPermission(RightsEnum.Write)) {
                    this.$emit('move-all-appointment', event, this)
                }
            },
            stopSelectItemToMove() {
                this.$emit('stop-move-appointment', this)
            },
            updateDuration(duration) {
                console.log('duration ' + duration)
            },
            separator($event) {
                if(this.item.duration >= 25) {
                    return 'border-b border-black'
                }

                return ''
            },
            isReason(reason) {
                return reason.id === this.item.reason_id
            },
            isPlace(place) {
                return place.id === this.item.place_id
            },
            reasonName(id) {
                const reasons = this.$store.state.account.reasons
                const found = reasons.find(element => element.id == id)

                return found.name;
            },
            placeName(id) {
                const places = this.$store.state.account.places
                const found = places.find(element => element.id == id)

                return found.name;
            },
            personName(uuid) {
                const persons = this.$store.state.account.persons
                if(persons[uuid])
                {
                    return persons[uuid].name
                }

                return ''
            },
            personEmail(uuid) {
                const persons = this.$store.state.account.persons
                if(persons[uuid])
                {
                    return persons[uuid].email
                }

                return ''
            },
            personPhone(uuid) {
                const persons = this.$store.state.account.persons
                if(persons[uuid])
                {
                    return persons[uuid].phone
                }

                return ''
            },
            remove() {
                this.$emit('remove-appointment', this.item);
            },
        },
        created() {
            const reasons = this.$store.state.account.reasons;

            const timeArray = this.item.time.toString().split(':');
            const minutes = ((+timeArray[0]) * 60 + (+timeArray[1]));
                
            let color = reasons.find(this.isReason)?.color;
            if(color)
            {
                this.color = color;

                const hex = ColorHelper.hexToRgb(color);

                let hov = 70;
                if(hex.r + hex.g + hex.b > 384) hov = -50;

                let rgb = "rgb(" + (hex.r + hov) + ", " + (hex.g + hov) + ", " + (hex.b + hov) + ")";
                this.colorHover = rgb;
            }

            this.top = parseFloat((minutes - this.agendaStart * 60) * 100 / (this.agendaDuration * 60)).toFixed(2) + '%';
            this.zIndex = minutes + 1;
            this.height = parseFloat(this.item.duration * 100 / (this.agendaDuration * 60)).toFixed(2) + '%';


            const places = this.$store.state.account.places
            let colorPlace = places.find(this.isPlace)?.color
            if(colorPlace)
            {
                this.colorPlace = colorPlace;
            }
        },
        computed: {
            styleObject () {
                if(this.selected == this.item.id)
                {
                    //style="box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;"
                    return {
                    //'border': '2px solid red',
                    //'box-shadow': '0 0 8px red',
                    'box-shadow': 'rgba(0, 0, 0, 1.0) 0px 0px 38px, rgba(0, 0, 0, 1.0) 0 0 30px',
                    '--color': this.color,
                    '--color-hover': this.colorHover
                    }
                }

                return {
                '--color': this.color,
                '--color-hover': this.colorHover
                }
            },
            timeFormatted() {
                var timeArray = this.item.time.toString().split(':');
                const minutes = timeArray[1].padStart(2, '0');
                return timeArray[0].padStart(2, '0') + 'h' + (minutes != '00' ? minutes : '');
            },
            lastClock() {
                var timeArray = this.item.time.toString().split(':');

                const durationHour = '' + parseInt(parseInt((this.item.duration + parseInt(timeArray[1])) / 60) + parseInt(timeArray[0]));
                const durationMinutes = '' + parseInt((this.item.duration + parseInt(timeArray[1])) % 60);

                const minutes = durationMinutes.padStart(2, '0');
                return durationHour.padStart(2, '0') + 'h' + (minutes != '00' ? minutes : '');
            },
            hasPermissionWrite() {
                return userService.hasPermission(RightsEnum.Write)
            },
        },
    }
</script>

<template>
<div>
    <div class="rdz absolute m-0 border border-black rounded flex left-1/2 w-[95%] pl-2
            select-none opacity-90 -translate-x-1/2 shadow-sm shadow-[#676767] cursor-pointer"
        :class="['hover:bg-[var(--color-hover)]']"
        :style="styleObject"
        v-click.press="selectItem"
    >
        <div class="w-full relative pr-1 py-0 overflow-hidden flex flex-col justify-between">
            <div
                v-show="hasPermissionWrite"
                v-if="item.duration >= 18"
                @mousedown="selectItemToMoveUp"
                class="absolute h-2 top-0 w-full leading-none text-center text-[11px] cursor-row-resize">
                <span>=</span>
            </div>
            <div class="h-full my-3 overflow-hidden" @mousedown="selectItemToMoveAll">
                <div
                    v-show="item.duration >= 18"
                    class="mx-auto my-0 pb-0.5 w-full flex justify-between text-[9px]"
                    :class="separator()"
                >
                    <div class="hidden xl:block">{{ timeFormatted }} - {{ lastClock }}</div>
                    <div class="block xl:hidden">{{ timeFormatted }}</div>
                    <div>{{ item.duration }}min</div>
                    <div class="w-3 h-3 border border-black" :style="{'background-color': colorPlace}"></div>
                </div>

                <div v-show="item.duration >= 25" class="text-[11px]">
                    <p class="m-1 italic text-center" v-if="item.person_uuid">{{ personName(item.person_uuid) }}</p>
                    <p class="m-1 text-justify">{{ item.description }}</p>
                </div>
            </div>
            <div
                v-show="hasPermissionWrite"
                @mousedown="selectItemToMoveDown"
                class="absolute bottom-0 mb-1 h-2 w-full text-center leading-none text-[11px] cursor-row-resize">
                =
            </div>
        </div>
        <div
            class="w-2 bg-slate-100 hover:bg-slate-600 opacity-50"
            @click="toggle" aria-haspopup="true">
        </div>
    </div>

    <OverlayPanel ref="op" :baseZIndex="1450">
        <div v-show="hasPermissionWrite" @click="remove()" class="hover:cursor-pointer flex mb-4">
            <icon name="trash-o" :size="16" color="black" class="w-6 h-6 mx-auto" />
        </div>
        <p><span class="font-bold">De</span> {{ timeFormatted }} <span class="font-bold">à</span> {{ lastClock }}</p>
        <p><span class="font-bold">Durée :</span> {{ item.duration }} min</p>
        <p><span class="font-bold">Motif :</span> {{ reasonName(item.reason_id) }}</p>
        <p><span class="font-bold">Lieu :</span> {{ placeName(item.place_id) }}</p>
        <p><span class="font-bold">Personne :</span> {{ personName(item.person_uuid) }}</p>
        <p>
            <span class="font-bold">Email :</span> <a class="hover:underline" :href="'mailto:' + personEmail(item.person_uuid)">
                {{ personEmail(item.person_uuid) }}
            </a>
        </p>
        <p>
            <span class="font-bold">Tél. :</span> <a class="hover:underline" :href="'tel:' + personPhone(item.person_uuid)">
                {{ personPhone(item.person_uuid) }}
            </a>
        </p>
        <p class="w-56"><span class="font-bold">Description :</span> {{ item.description }}</p>
    </OverlayPanel>
</div>
</template>

<style scoped>

.rdz {
    background-color: var(--color);
    top: v-bind('top');
    z-index: v-bind('zIndex');
    height: v-bind('height');
}

</style>